<template>
  <div class="timesheetpage">
    <div class="modals">
      <va-modal
        size="large"
        position="top"
        v-model="showCommentDialog"
        :title=" $t('modal.editTitle') "
        cancelClass="none"
        :okText=" $t('modal.confirm') "
        :message=" $t('modal.commentMessage') "
        noOutsideDismiss
        noEscDismiss
        @cancel="close"
        @ok="save"
      >
        <div class="form-elements">
          <form>
            <div class="row">
              <div class="flex xs12">
                <va-input
                  v-model="comment"
                  placeholder="Please provide your comment."
                  label="Comment"
                  v-on:keydown.enter.prevent="doNothing"
                ></va-input>
              </div>
            </div>
          </form>
        </div>
      </va-modal>
    </div>
    <div class="row row-equal">
      <div class="flex xs12 lg7">
        <timesheet-list
          :timesheets="timesheetList"
          :loading="loading"
          @selectedTimesheetChanged="selectedTimesheetChanged"
          @refreshList="refreshList"
          :searchMode="searchMode"
          :title="listTitle"
          :canDownload="canDownload"
          :showFilterRange="showFilterRange"
        ></timesheet-list>
      </div>
      <div class="flex xs12 lg5">
        <timesheet
          :mode="mode"
          :timesheet="timesheet"
          @totalHourChanged="totalHourChanged"
          @submitClicked="submitClicked"
          @saveClicked="saveClicked"
          @approveClicked="approveClicked"
          @rejectClicked="rejectClicked"
          @adjustClicked="adjustClicked"
          @processClicked="processClicked"
        ></timesheet>
      </div>
    </div>
  </div>
</template>

<script>
import TimesheetList from './TimesheetList'
import Timesheet from './Timesheet'
import timesheetService from '../../api/timesheetService'
import dataFactoryService from '../../api/dataFactoryService'
import userCacheService from '../../api/userCacheService'

export default {
  name: 'timsheet-page',
  props: {
    pageType: String,
  },
  components: {
    TimesheetList,
    Timesheet,
  },
  data () {
    return {
      timesheetList: [],
      timesheet: {},
      loading: false,
      searchMode: false,
      selectedItemIndex: -1,
      mode: '',
      listTitle: '',
      showCommentDialog: false,
      submitButtonClicked: false,
      approveButtonClicked: false,
      rejectButtonClicked: false,
      processButtonClicked: false,
      adjustButtonClicked: false,
      comment: '',
      canDownload: false,
      showFilterRange: false,
    }
  },
  async created () {
    await this.initialize()
  },
  watch: {
    showCommentDialog (val) {
      val || this.close()
      if (val) {
        console.log('close called')
      }
    },
  },
  methods: {
    doNothing (e) {
      if (e) {
        e.preventDefault()
      }
    },
    close () {
      this.showCommentDialog = false
      this.showCommentDialog = false
      this.rejectButtonClicked = false
      this.approveButtonClicked = false
      this.processButtonClicked = false
      this.adjustButtonClicked = false
      this.submitButtonClicked = false
      this.comment = ''
    },
    async save () {
      try {
        this.loading = true
        if (this.submitButtonClicked) {
          await this.submit(this.timesheet)
        } else if (this.rejectButtonClicked) {
          await this.reject(this.timesheet)
        } else if (this.approveButtonClicked) {
          await this.approve(this.timesheet)
        } else if (this.adjustButtonClicked) {
          await this.adjust(this.timesheet)
        } else if (this.processButtonClicked) {
          await this.process(this.timesheet)
        }
      } catch (error) {
        this.showError(error)
      }
      this.showCommentDialog = false
      this.rejectButtonClicked = false
      this.approveButtonClicked = false
      this.processButtonClicked = false
      this.adjustButtonClicked = false
      this.submitButtonClicked = false
      this.loading = false
      this.comment = ''
    },
    async saveClicked (timesheet) {
      try {
        this.loading = true
        await timesheetService.update(timesheet.id, timesheet)
      } catch (error) {
        this.showError(error)
      }
      this.loading = false
    },
    async submit (timesheet) {
      try {
        await timesheetService.submit(timesheet.id, this.timesheet, this.comment)
        this.timesheetList.splice(this.selectedItemIndex, 1)
        await this.initTimesheet()
        this.showMessage('Your timesheet has been submitted for approval. You will receive notification as soon as it is approved by the manager.')
      } catch (error) {
        this.showError(error)
      }
    },
    submitClicked (timesheet) {
      this.showCommentDialog = true
      this.submitButtonClicked = true
    },
    async initTimesheet () {
      if (this.timesheetList.length > 0) {
        await this.loadTimesheet(this.timesheetList[0])
      } else {
        this.timesheet = {}
      }
    },
    async approveClicked (timesheet) {
      this.showCommentDialog = true
      this.approveButtonClicked = true
    },
    async approve (timesheet) {
      try {
        await timesheetService.approve(
          timesheet.employee_id,
          timesheet.id,
          this.comment
        )
        this.timesheetList.splice(this.selectedItemIndex, 1)
        await this.initTimesheet()
        this.showMessage('Timesheet will be assigned to system administrator for processing.')
      } catch (error) {
        this.showError(error)
      }
    },
    async rejectClicked (timesheet) {
      this.rejectButtonClicked = true
      this.showCommentDialog = true
    },
    async reject (timesheet) {
      try {
        await timesheetService.reject(
          timesheet.employee_id,
          timesheet.id,
          this.comment
        )
        this.timesheetList.splice(this.selectedItemIndex, 1)
        await this.initTimesheet()
        this.showMessage('Employee will be notified by the system to check the timesheet.')
      } catch (error) {
        this.showError(error)
      }
    },
    async adjustClicked (timesheet) {
      this.showCommentDialog = true
      this.adjustButtonClicked = true
    },
    async adjust (timesheet) {
      try {
        await timesheetService.adjust(
          timesheet.employee_id,
          timesheet.id,
          timesheet,
          this.comment
        )
        this.timesheetList.splice(this.selectedItemIndex, 1)
        await this.initTimesheet()
        this.showMessage('Employee will be notified by the system to check the timesheet.')
      } catch (error) {
        this.showError(error)
      }
    },
    async processClicked (timesheet) {
      this.showCommentDialog = true
      this.processButtonClicked = true
    },
    async process (timesheet) {
      try {
        await timesheetService.process(
          timesheet.employee_id,
          timesheet.id,
          this.comment
        )
        this.timesheetList.splice(this.selectedItemIndex, 1)
        await this.initTimesheet()
        this.showMessage('Employee will be notified by the system to check the timesheet.')
      } catch (error) {
        this.showError(error)
      }
    },
    totalHourChanged (days) {
      var timesheetListItem = this.timesheetList.find(item => {
        return item.id === this.timesheet.id
      })
      if (timesheetListItem !== null) {
        // console.log('timesheet list days updated to ' + days)
        timesheetListItem.days = days
      }
    },
    async initialiseTimesheets (start, end) {
      this.mode = this.pageType
      var user = userCacheService.getCurrentUser()
      this.searchMode = user.roles.manager || user.roles.admin || user.roles.super_admin
      switch (this.pageType) {
        case 'open':
          this.listTitle = 'Your current timesheets'
          this.showFilterRange = false
          return timesheetService.getOpen()
        case 'all':
          this.listTitle = 'Your timesheets history'
          this.showFilterRange = true
          this.canDownload = user.roles.admin || user.roles.super_admin || user.roles.manager
          return timesheetService.getAll(start, end)
        case 'tobeapproved':
          this.listTitle = 'Pending approval'
          this.showFilterRange = false
          return timesheetService.getToBeApproved()
        case 'tobeprocessed':
          this.listTitle = 'Pending processing'
          this.showFilterRange = false
          return timesheetService.getToBeProcessed()
        default:
          this.listTitle = 'Unknown page'
          return []
      }
    },
    async initialize (start, end) {
      this.loading = true
      try {
        this.timesheet = {}
        let timesheetResult = await this.initialiseTimesheets(start, end)
        this.timesheetList = dataFactoryService.createTimesheetListModel(
          timesheetResult.payload.data
        )
        await this.initTimesheet()
      } catch (error) {
        this.showError(error)
      }
      this.loading = false
    },
    async selectedTimesheetChanged (item) {
      await this.loadTimesheet(item)
    },
    async refreshList (start, end) {
      console.log('start ' + start)
      console.log('end ' + end)
      await this.initialize(start, end)
    },
    async loadTimesheet (item) {
      this.loading = true
      try {
        if (item.id !== this.timesheet.id) {
          this.selectedItemIndex = this.timesheetList.indexOf(item)
          let itemResult = await timesheetService.get(item.id)
          this.timesheet = dataFactoryService.createTimesheetModel(
            itemResult.payload.data
          )
          // console.log("loaded timesheet -> " + JSON.stringify(this.timesheet));
        }
      } catch (error) {
        this.showError(error)
      }
      this.loading = false
    },
    showError (message) {
      console.log(message)
      this.showToast(message, {
        icon: 'fa-exclamation',
        position: 'bottom-right',
        duration: 5000,
      })
    },
    showMessage (message) {
      this.showToast(message, {
        icon: 'fa-check',
        position: 'bottom-right',
        duration: 5000,
      })
    },
  },
}
</script>

<style lang="scss">
.row-separated {
  .flex + .flex {
    border-left: 1px solid #e3eaeb;
  }

  @include media-breakpoint-down(xs) {
    p:not(.display-2) {
      font-size: 0.875rem;
    }
  }
}
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.timesheetpage {
  .va-card {
    margin-bottom: 0 !important;
  }
}
</style>
